import { loadStripe } from '@stripe/stripe-js';

// Safe function to get Stripe publishable key
export const getStripeKey = () => {
  const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  
  // Check if key is missing or contains placeholder values
  if (!key || 
      key === 'your_stripe_publishable_key_here' || 
      key === 'pk_test_your_stripe_publishable_key_here' ||
      key === 'pk_test_your_key_here') {
    console.warn('Stripe publishable key not configured. Payment features will be disabled.');
    return null;
  }
  
  // Validate key format (basic check)
  if (!key.startsWith('pk_test_') && !key.startsWith('pk_live_')) {
    console.warn('Invalid Stripe publishable key format. Payment features will be disabled.');
    return null;
  }
  
  return key;
};

// Safe Stripe initialization
export const initStripe = async () => {
  try {
    const key = getStripeKey();
    if (!key) {
      console.warn('Stripe initialization skipped - no valid publishable key');
      return null;
    }
    
    const stripe = await loadStripe(key);
    if (!stripe) {
      console.error('Failed to load Stripe');
      return null;
    }
    
    console.log('Stripe initialized successfully');
    return stripe;
  } catch (error) {
    console.error('Error initializing Stripe:', error);
    return null;
  }
};

// Create Stripe promise for use with Elements
export const createStripePromise = () => {
  const key = getStripeKey();
  return key ? loadStripe(key) : null;
};

// Check if Stripe is available
export const isStripeAvailable = () => {
  return getStripeKey() !== null;
};

// Get Stripe configuration
export const getStripeConfig = () => {
  return {
    publishableKey: getStripeKey(),
    currency: process.env.REACT_APP_STRIPE_CURRENCY || 'USD',
    isAvailable: isStripeAvailable()
  };
};
